import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PasswordCheckItem from './PasswordCheckItem';
import PasswordStrengthBar from './PasswordStrength';
export const CHECK_REGEX = {
    uppercase: /[A-Z]/,
    lowercase: /[a-z]/,
    number: /\d/,
    specialChar: /[~!@#$^*\-_=[\]{}|;,.?]/,
};
export default function PasswordChecksList({ password, validationMessages, enabledChecks, }) {
    const allChecks = [
        {
            key: 'uppercase',
            regex: CHECK_REGEX.uppercase,
            text: validationMessages.uppercaseLetter,
        },
        {
            key: 'lowercase',
            regex: CHECK_REGEX.lowercase,
            text: validationMessages.lowercaseLetter,
        },
        {
            key: 'number',
            regex: CHECK_REGEX.number,
            text: validationMessages.number,
        },
        {
            key: 'specialChar',
            regex: CHECK_REGEX.specialChar,
            text: validationMessages.especialChar,
        },
    ];
    const passwordChecks = allChecks.filter((check) => enabledChecks.includes(check.key));
    const passed = passwordChecks.filter((r) => r.regex.test(password)).length;
    const total = passwordChecks.length;
    return (_jsxs("div", { className: "mt-2", children: [_jsx(PasswordStrengthBar, { strength: passed, total: total }), _jsx("ul", { className: "list-unstyled m-0 d-flex flex-column gap-2", children: passwordChecks.map(({ key, regex, text }) => (_jsx(PasswordCheckItem, { password: password, regex: regex, text: text }, key))) })] }));
}
//# sourceMappingURL=PasswordCheckList.js.map